import React, { useState, useEffect } from "react";
import { selectMentoryCatgeory } from "./actions";

import { useRedirect } from "react-admin";
import Skeleton from "@material-ui/lab/Skeleton";
import { useDispatch, useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import Social from "../../images/social1.png";
import { useHistory } from "react-router-dom";
import { useMentorData } from "./hooks";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },

  circularProgress: {
    marginTop: "-2%",
    marginLeft: "auto",
    marginRight: "auto",
    color: "#2D3142",
  },

  title: {
    paddingBottom: 50,
    color: "#2D3142",
    textAlign: "center",
    fontSize: "45px",
    fontWeight: "700",
  },
  autoGridContainer: {
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingBottom: "30px",
  },
  autoGridItem: {
    paddingLeft: "15px",
    paddingRight: "15px",
    marginTop: "15px",
  },
  avatar: {
    marginTop: 10,
    width: 85,
    height: 85,
  },
}));

const AutoGrid = (props) => {
  const { mentorData } = useMentorData();
  const [skelton, setSkelton] = useState(false);
  const redirect = useRedirect();
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const mentorCategory = useSelector(
    (state) => state.userStats.selectedMentorCategory
  );

  useEffect(() => {
    setSkelton(false);
    dispatch(selectMentoryCatgeory(mentorCategory));
    const timer = setTimeout(() => {
      setSkelton(true);
    }, 10000);
    return () => clearTimeout(timer);
  }, [mentorCategory, dispatch]);

  return (
    <React.Fragment>
      <Typography className={classes.title}>
        {mentorData.loaded && "Meet the Mentors"}
      </Typography>
      {mentorData.data.length > 0 || mentorData.data.length === 0 ? (
        <Grid container className={classes.autoGridContainer}>
          {!mentorData.loading ? (
            mentorData.data.map((key) => (
              <Grid item xs={12} md={4} lg={3} className={classes.autoGridItem}>
                <Card key={key.id} className={classes.autoGridCard}>
                  {/* {skelton ? ( */}
                  <CardHeader
                    disableTypography={false}
                    avatar={
                      <Avatar
                        src={
                          key.profileImage && key.profileImage !== undefined
                            ? key.profileImage._url
                            : ""
                        }
                        className={classes.avatar}
                      />
                    }
                    action={<img src={Social} alt="badge" />}
                    title={skelton ? key.name : <Skeleton variant="text" />}
                    titleTypographyProps={{ variant: "h6" }}
                    subheader={
                      skelton ? (
                        `Mentoring : ${key.hoursConsulted} hrs,${
                          key.hasOwnProperty("userBadge")
                            ? key.userBadge.badgeIcon
                            : ""
                        }`
                      ) : (
                        <Skeleton variant="text" />
                      )
                    }
                    subheaderTypographyProps={{ variant: "body1" }}
                  ></CardHeader>
                  {/* ) : (
                  <Skeleton variant="rect" width={"100%"} height={"100%"}/>
                )} */}
                  <CardActions className={classes.autoGridCardActions}>
                    <Button
                      color="primary"
                      onClick={() => {
                        // redirect(`/mentor-details/${key.id}`);
                        // handleClickOpen(key.availability.id)
                        history.push({
                          pathname: `/mentor-details/${key.name.replace(
                            " ",
                            "-"
                          )}`,

                          state: {
                            id: key.id,
                          },
                        });
                      }}
                    >
                      VIEW PROFILE
                    </Button>
                    <Button
                      color="secondary"
                      onClick={() => {
                        redirect(`/new-appointment/${key.id}`);
                      }}
                    >
                      BOOK APPOINTMENT
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))
          ) : (
            <CircularProgress className={classes.circularProgress} />
          )}
        </Grid>
      ) : (
        // {/* <MentorDetailsDialog aid={() => getAid()} handleClose={handleClose} open={open} /> */}
        ""
      )}
    </React.Fragment>
  );
};

export default AutoGrid;
